// extracted by mini-css-extract-plugin
module.exports = {"tab":"_103a151b99--tab--G72lE","tab_selected":"_103a151b99--tab_selected--JH9Rr"};